import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { AdminStatusSwitchIcon } from '@/epics/adminManagment/pages/adminList/AdminStatusDialogContent';

export type TechnicianStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getTechnicianStatusDialogConfig(
  technicianName: string,
  isActive: boolean
): TechnicianStatusDialogConfig {
  const isActivating = !isActive;
  const prefix = isActivating
    ? 'Spowoduje to natychmiastowe przywrócenie dostępu do Pozytron dla '
    : 'Spowoduje to natychmiastowe ograniczenie dostępu do Pozytron dla ';
  const suffix = isActivating
    ? ' Czy na pewno chcesz aktywować tego technika?'
    : ' Czy na pewno chcesz dezaktywować tego technika?';
  return {
    title: isActivating ? 'Aktywować technika?' : 'Dezaktywować technika?',
    content: (
      <>
        <span>{prefix}</span>
        <span className="font-medium">{technicianName}.</span>
        <span>{suffix}</span>
      </>
    ),
    confirmButtonLabel: isActivating ? 'Aktywuj' : 'Dezaktywuj',
    confirmButtonLabelLoading: isActivating
      ? 'Aktywowanie…'
      : 'Dezaktywowanie…',
    icon: <AdminStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
